export default {
	name:'form',
    checkFlag:false,
	initalize:function(vue) {
		this.Vue = vue;
	},
	validate: function($f,event,callBack) {

			event.preventDefault();

			if(this.checkFlag)return;

			var submitFlag = true;
			var postParams = {};
			var obj = this;
			var funcs = new Array();
			funcs['domain'] = this.isValidDomain;
			funcs['email'] = this.isValidEmail;
			funcs['userid'] = this.isValidUserid;
			funcs['userpw'] = this.isValidUserpw;
			funcs['hangul'] = this.hasHangul;
			funcs['number'] = this.isNumeric;
			funcs['engonly'] = this.alphaOnly;
			funcs['normal'] = this.isSpecialCharacter;

			$($f.serializeArray()).each(function(k,f) {
				var $el = $('#'+f.name); 
				if(!$el.val() && $el.attr('required')) {
					$el.focus();
					$el.parent().parent('.form-group').addClass('md-invalid');
					//console.log($el.prop('tagName'));
					if($el.prop('tagName')=='SELECT') {
						$el.off('change');
						$el.on('change',function() {
							if($(this).val()) {
								$(this).parent().parent('.form-group').removeClass('md-invalid');
							}
						});

					} else {
						$el.off('keyup');
						$el.on('keyup',function() {
							if($(this).val()) {
								$(this).parent().parent('.form-group').removeClass('md-invalid');
							}
						});
					}
					submitFlag = false;
					return false;
				} else {
					if($el.attr('option')) {
						var checkFunc = funcs[$el.attr('option')];
						if(!checkFunc($el.val())) {
							$el.focus();
							$el.parent().parent('.form-group').addClass('md-warning-invalid');
							$el.off('keyup');
							$el.on('keyup',function() {
								$(this).parent().parent('.form-group').removeClass('md-warning-invalid');
								
							});
							submitFlag = false;
							return false;
						}
					} 
					if($el.attr('match')) {
						
						if($el.val()!=$($el.attr('match')).val()) {
							$el.val('');
							$el.focus();
							$el.parent().parent('.form-group').addClass('md-warning-invalid');
							$el.off('keyup');
							$el.on('keyup',function() {
								$(this).parent().parent('.form-group').removeClass('md-warning-invalid');
								
							});
							submitFlag = false;
							return false;
						}
					}

				}
				postParams[f.name] = $el.val();
			});
			if(submitFlag) {
				if(!$f.attr('action'))return true;
				//console.log('------>',JSON.stringify(postParams));
				this.sendPost(postParams,$f.attr('action'),callBack);
			} else  return false;
	},
	validateOnly: function($f) {
			
			var submitFlag = true;
			var postParams = {};
			var obj = this;
			var funcs = new Array();
			funcs['domain'] = this.isValidDomain;
			funcs['email'] = this.isValidEmail;
			funcs['userid'] = this.isValidUserid;
			funcs['userpw'] = this.isValidUserpw;
			funcs['hangul'] = this.hasHangul;
			funcs['number'] = this.isNumeric;
			funcs['engonly'] = this.alphaOnly;
			funcs['normal'] = this.isSpecialCharacter;

			$($f.serializeArray()).each(function(k,f) {
				var $el = $('#'+f.name); 

				if($el) {
				
					if(!$el.val() && $el.attr('required')) {
						if($el.prop('tagName')=='SELECT') {
							$el.focus();
							$el.parent().parent('.form-group').addClass('md-invalid');
						
							$el.off('change');
							$el.on('change',function() {
								if($(this).val()) {
									$(this).parent().parent('.form-group').removeClass('md-invalid');
								}
							});

						} else {
							
							if(!$el.hasClass('md-select-value')) {
								$el.focus();
								$el.parent().parent('.form-group').addClass('md-invalid');
							
								if($el.attr('type')=='date') {
									$el.off('change');
									$el.on('change',function() {
										if($(this).val()) {
											$(this).parent().parent('.form-group').removeClass('md-invalid');
										}
									});
								} else {
									$el.off('keyup');
									$el.on('keyup',function() {
										if($(this).val()) {
											$(this).parent().parent('.form-group').removeClass('md-invalid');
										}
									});
								}
							} 
						}
						submitFlag = false;
						return false;
					} else {
						if($el.attr('option')) {
							var checkFunc = funcs[$el.attr('option')];
							if(!checkFunc($el.val())) {
								$el.focus();
								$el.parent().parent('.form-group').addClass('md-warning-invalid');
								$el.off('keyup');
								$el.on('keyup',function() {
									$(this).parent().parent('.form-group').removeClass('md-warning-invalid');
									
								});
								submitFlag = false;
								return false;
							}
						} 
						if($el.attr('match')) {
							
							if($el.val()!=$($el.attr('match')).val()) {
								$el.val('');
								$el.focus();
								$el.parent().parent('.form-group').addClass('md-warning-invalid');
								$el.off('keyup');
								$el.on('keyup',function() {
									$(this).parent().parent('.form-group').removeClass('md-warning-invalid');
									
								});
								submitFlag = false;
								return false;
							}
						}

					}
					postParams[f.name] = $el.val();
				}
			});
			if(submitFlag)	return postParams;
			else return false;

	},
	number_format: function(number) {
		var nf = new Intl.NumberFormat(["en-US"], {
		
		});
		return nf.format(number);
	},
	sendPost: function(params,action,callBack,mutilProcess) {
		
		
		if(mutilProcess!='multi') {
			if(this.checkFlag)return;
			this.checkFlag = true;
		
		}
		var thisObj = this.Vue;
		var obj = this;
		
		$.ajax({url:thisObj.$VARS.url+action,
				data:params,
				headers: {
				   "memberkey":sessionStorage.getItem('memberkey'),
					"devToken":thisObj.$VARS.devToken,
					//"appToken":sessionStorage.getItem('appToken'),
					//"appdevice":sessionStorage.getItem('dev')
				},
			    dataType:'json',
				type:'post',
				cache: false,
				success:function (response) {
					if(thisObj.$VARS.debug) {
						console.log(response);
					}
					obj.checkFlag = false;
					
					if(response.result=='noAuth') {
						sessionStorage.setItem('memberkey',''),
						thisObj.$router.push({path:'/member/login'});
						return;
					}

					if(callBack) {
						callBack(response);
					}
				},
				error:function(request,status,error){
					obj.checkFlag = false;
					console.log("code:"+request.status+"\n"+"message:"+request.responseText+"\n"+"error:"+error);
				}
		})
		
	},
	getServerData: function(params,action,callBack,mutilProcess) {
		if(mutilProcess!='multi') {
			if(this.checkFlag)return;
			this.checkFlag = true;
		
		}
		var thisObj = this.Vue;
		var obj = this;
		
		$.ajax({url:thisObj.$VARS.url+action,
				data:params,
				headers: {
				   "memberkey":sessionStorage.getItem('memberkey'),
				   "devToken":thisObj.$VARS.devToken,	
		   		   //"appToken":sessionStorage.getItem('appToken'),
				   //"appdevice":sessionStorage.getItem('dev')
		
				},
				dataType:'json',
				type:'get',
				cache: false,
				success:function (response) {
					if(thisObj.$VARS.debug) {
						console.log(response);
					}
					 obj.checkFlag = false;
					 if(response.result=='noAuth') {
						sessionStorage.setItem('memberkey',''),
						thisObj.$router.push({path:'/member/login'});
						return;
					}

					if(callBack) {
						callBack(response);
					}
				},
				error:function(request,status,error){
					 obj.checkFlag = false;
					console.log("code:"+request.status+"\n"+"message:"+request.responseText+"\n"+"error:"+error);
				}
		})
		
	},
	isValidDomain: function(value) {
		var pattern = /^[_a-zA-Z가-힝0-9-]+\.[a-zA-Z가-힝0-9-\.]+[a-zA-Z]+(\/[a-zA-z0-9-\/\.]{0,})*$/;
		return (pattern.test(value.replace(/http:\/\//g, ''))) ? true : false;
	},
	isValidEmail: function(value) {
		var pattern = /^[_a-zA-Z0-9-\.]+@[\.a-zA-Z0-9-]+\.[a-zA-Z]+$/;
		return (pattern.test(value)) ? true : false;
	},
	isValidUserid: function(value) { 
		var pattern = /^[a-z]{1}[a-z0-9]{3,14}$/;
		return (pattern.test(value)) ? true : false;
	},
	isValidUserpw: function(value) { 
		if(value.length<8 || value.length>15)return false;
		var pattern = /([a-zA-Z0-9].*[!,@,#,$,%,^,&,*,?,_,~,-])|([!,@,#,$,%,^,&,*,?,_,~,-].*[a-zA-Z0-9])/
		return (pattern.test(value)) ? true : false;
	},
	hasHangul: function(value) {
		var pattern = /[가-힝]/;
		return (pattern.test(value)) ? true : false;
	},
	alphaOnly: function(value) {
		var pattern = /^[a-zA-Z]+$/;
		return (pattern.test(value)) ? true : false;
	},
	isSpecialCharacter: function(value) {
		var pattern = /[a-zA-Z가-힝0-9]/;
		return (pattern.test(value)) ? true : false;
	},
	isNumeric: function(value) {
		var pattern = /^[0-9]+$/;
		return (pattern.test(value)) ? true : false;
	},
	tempImage: function(tmp,func) {

		var formData = new FormData();
		formData.append('tmp',tmp);	
		var thisObj = this.Vue;
		$.ajax({
				url: thisObj.$VARS.url+'memberProc/getTempImage',
				headers: {
					   "memberkey":sessionStorage.getItem('memberkey'),
						"devToken":thisObj.$VARS.devToken,
				},
				processData: false,
				contentType: false,
				data: formData,
				type: 'POST',
				dataType:'json',
				success: function(response){
					if(response.result=='succ') {
						func(thisObj.$VARS.url+response.img);
					}
				},
				error:function(request,status,error){
					console.log("code:"+request.status+"\n"+"message:"+request.responseText+"\n"+"error:"+error);
				}
  
		});
	},
	strip_tags: function(input, allowed) {
		allowed = (((allowed || "") + "").toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join(''); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
		var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
		commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
		return input.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
			return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
		});
	},
	getStrCut: function(string,length) {
		if(string.length >= length){
			return string.substr(0,length)+"..";
		} else return string;
	}

}

